import { useEffect, useState } from "react";
import { Trophy, Crown } from "lucide-react";
import api, { inr } from "@/lib/api";

const RANK_TONE = ["text-[#D4AF37]", "text-white/80", "text-[#CD7F32]"];

export const Leaderboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/leaderboard").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data || !data.enabled) return null;
  return (
    <div className="bg-[#0A0A0A] border border-white/10 p-6 mt-6" data-testid="leaderboard-card">
      <div className="flex items-center justify-between gap-3 mb-1">
        <div className="flex items-center gap-2">
          <Trophy size={14} className="text-[#D4AF37]" />
          <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#D4AF37]">Top Referrers</p>
        </div>
        <span className="font-accent text-[9px] tracking-[0.2em] uppercase text-white/35" data-testid="leaderboard-month">{data.month}</span>
      </div>
      {data.prize && (
        <p className="text-sm text-white/60 leading-relaxed flex items-start gap-2 mt-3" data-testid="leaderboard-prize">
          <Crown size={14} className="text-[#D4AF37] shrink-0 mt-0.5" /> {data.prize}
        </p>
      )}
      <div className="mt-4 border border-[#D4AF37]/30 bg-[#D4AF37]/5 px-4 py-3 flex items-center justify-between" data-testid="leaderboard-my-rank">
        <span className="text-xs text-white/60">Your rank this month</span>
        <span className="font-display text-xl text-[#D4AF37]">{data.my_rank ? `#${data.my_rank}` : "—"}<span className="text-xs text-white/40 ml-2">{data.my_count} referral{data.my_count === 1 ? "" : "s"}</span></span>
      </div>
      {data.items.length > 0 ? (
        <ol className="mt-4 space-y-2" data-testid="leaderboard-list">
          {data.items.map((r) => (
            <li key={r.rank} className={`flex items-center justify-between text-xs px-2 py-1.5 ${r.is_me ? "bg-white/5 border-l-2 border-[#D4AF37]" : ""}`} data-testid={`leaderboard-row-${r.rank}`}>
              <span className="flex items-center gap-3">
                <span className={`font-display text-base w-6 ${RANK_TONE[r.rank - 1] || "text-white/40"}`}>{r.rank}</span>
                <span className="text-white/80">{r.name}{r.is_me && <span className="text-[#D4AF37] ml-2">(you)</span>}</span>
              </span>
              <span className="text-white/45">{r.count} friend{r.count === 1 ? "" : "s"} · {inr(r.amount)}</span>
            </li>
          ))}
        </ol>
      ) : (
        <p className="mt-4 text-xs text-white/40" data-testid="leaderboard-empty">No referrals counted yet this month — be the first! A referral counts when your friend's first investment is approved.</p>
      )}
    </div>
  );
};
